// Discriminant values for resolvePickerInputOnEnter return objects.
export const PICKER_ENTER_RESULT_KIND = Object.freeze({
  SUGGESTION: 'suggestion',
  EMAIL: 'email',
})

// SpiceDB subject types on GET /permissions tuples (not client picker chips).
export const PERMISSION_SUBJECT_TYPES = Object.freeze({
  USER: 'user',
  USER_GROUP: 'user_group',
  ORGANIZATION: 'organization',
})

// Discriminant for client-side pending recipient chips (never round-tripped via API).
export const RECIPIENT_KINDS = Object.freeze({
  USER: 'user',
  USER_GROUP: 'user_group',
  USER_EMAIL: 'user_email',
})
